import { useState } from 'react';
import { X, Send, Loader2, CheckCircle } from 'lucide-react';
import api from '../api';

export default function SupportModal({ onClose }) {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!subject || !message) return;
    
    setLoading(true);
    setError(null);
    try {
      await api.post('/support', { subject, message });
      setSuccess(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (err) {
      setError('Failed to send message. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div 
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }} 
        onClick={onClose}
      ></div>
      
      <div className="glass animate-fade-in" style={{ position: 'relative', width: '90%', maxWidth: '500px', padding: '2rem', borderRadius: 'var(--radius-lg)', background: '#1e293b', border: '1px solid var(--surface-border)', zIndex: 1001, boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)' }}>
        <button 
          onClick={onClose}
          style={{ position: 'absolute', top: '1rem', right: '1rem', background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer' }}
        >
          <X size={20} />
        </button>

        <h2 style={{ margin: '0 0 1.5rem 0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          Contact Support
        </h2>

        {success ? (
          <div style={{ textAlign: 'center', padding: '2rem 0' }}>
            <CheckCircle size={48} color="var(--success)" style={{ marginBottom: '1rem' }} />
            <h3 style={{ margin: 0 }}>Message Sent!</h3>
            <p className="text-muted">We will get back to you shortly.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {error && (
              <div style={{ padding: '0.75rem', background: 'rgba(239, 68, 68, 0.1)', color: 'var(--danger)', borderRadius: 'var(--radius-md)', fontSize: '0.85rem' }}>
                {error}
              </div>
            )}
            
            <div className="form-group">
              <label>Subject</label>
              <input 
                type="text" 
                className="form-control" 
                placeholder="What do you need help with?" 
                value={subject}
                onChange={e => setSubject(e.target.value)}
                required
              />
            </div>
            
            <div className="form-group">
              <label>Message</label>
              <textarea 
                className="form-control" 
                placeholder="Describe your issue in detail..." 
                rows={5}
                value={message}
                onChange={e => setMessage(e.target.value)}
                required
                style={{ resize: 'vertical' }}
              ></textarea>
            </div>
            
            <button type="submit" className="btn btn-primary" disabled={loading || !subject || !message} style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem' }}>
              {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
              Send Message
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
